import React, { forwardRef, useImperativeHandle } from "react";
import { useDispatch, useSelector } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";

import HorizontalAssetList from "../../Shared/AssetPreviewList/HorizontalAssetList";
import BackupCreative from "./BackupCreative";
import { selectCreative } from "../../../actions/app/creatives";
import HelperTooltip from "../../Shared/HelperTooltip/HelperTooltip";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    // border: "1px solid rgba(0, 0, 0, 0.26)",
    boxShadow: "none",
    display: "flex",
    justifyContent: "space-around"
  },
  thumbsContainer: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    width: "100%"
  },
  h6: {
    fontWeight: 400,
    fontSize: "1.15rem"
  }
}));

export default forwardRef(({
  isClickEnabled,
  isDragDisabled,
  selectedCreatives,
  setSelectedCreatives,
  isThumbnailEnabled
}, ref) => {
  const [selectedIds, setSelectedIds] = React.useState([]);
  const classes = useStyles();
  const dispatch = useDispatch();
  const placements = useSelector((state) => state.creatives.assignedPlacements);
  const creatives = useSelector((state) => state.creatives);

  const handleSelectCard = (id) => {
    if (selectedIds.includes(id)) {
      setSelectedIds(selectedIds.filter((selectedId) => selectedId !== id));
    } else {
      setSelectedIds([...selectedIds, id]);
    }
  };

  const deselectCards = () => {
    setSelectedIds([]);
    dispatch(selectCreative(""));
  };

  useImperativeHandle(ref, () => ({
    validate() {
      for (let cid of creatives.allIds) {
        let creative = creatives.byId[cid];

        if (creative.file && creative.file.type.includes("zip")) {
          if (!creative.backupId) {
            return {
              hasErrors: true,
              message:
                "There are some H5 files uploaded without a backup creative, please ensure all H5 creatives has a backup attached."
            };
          }
        }
      }

      return {
        hasErrors: false,
        message: ""
      };
    }
  }));

  return (
    <React.Fragment>
      <Typography variant="h6" className={classes.h6}>
        Add backup images for each creative
        <HelperTooltip tooltipText="If your primary asset is Rich Media or HTML5, a static backup image is required. " />
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <HorizontalAssetList
            selectedIds={selectedIds}
            handleSelectCard={handleSelectCard}
            isClickEnabled={isClickEnabled}
            isDragDisabled={isDragDisabled}
            isThumbnailEnabled={isThumbnailEnabled}
            isWeightEnabled={false}
          />
        </Grid>
        <Grid
          item
          xs={6}
          container
          direction="row"
          justify="space-around"
          alignItems="flex-start"
        >
          <BackupCreative
            selectedIds={selectedIds}
            deselectCards={deselectCards}
            selectedCreatives={selectedCreatives}
            setSelectedCreatives={setSelectedCreatives}
            placements={placements}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
});
